import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { searchBrands } from '../api/hooks/brands';
import { DeleteOutline } from '@mui/icons-material';
import {
  getParentCategories,
  searchCategories,
  getChildCategories,
} from '../api/hooks/categories';
import { RichTreeViewPro, useTreeViewApiRef } from '@mui/x-tree-view-pro';

interface ProductFiltersProps {
  onFilter: (selectedBrands: string[], selectedCategories: string[]) => void;
}

const ProductFilters = ({ onFilter }: ProductFiltersProps) => {
  const [selectedBrands, setSelectedBrands] = useState<string[]>([]);
  // const [brandPageIndex, setBrandPageIndex] = useState(0);
  const [brands, setBrands] = useState<any[]>([]);
  const [categorySearchResults, setCategorySearchResults] = useState<any[]>([
    { id: -1, label: 'Show Parent Categories' },
  ]);
  const [parentCategories, setParentCategories] = useState<any[]>([]);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const handleSearchBrands = (query: string) =>
    searchBrands(query).then((items) => setBrands(items || []));
  const handleSearchCategories = (query: string) =>
    searchCategories(query).then((items) =>
      setCategorySearchResults(items || [])
    );

  useEffect(() => {
    handleSearchBrands('*');
    getParentCategories().then((items) => setParentCategories(items || []));
  }, []);

  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
  // const [categoriesPageIndex, setCategoriesPageIndex] = useState(0);
  // const {
  //   data: categories,
  //   isFetching: isFetchingCategories,
  //   fetchNextPage: fetchCategoriesNextPage,
  // } = useCategoriesQuery({ limit: 10 });

  useEffect(() => {
    onFilter(selectedBrands, selectedCategories);
  }, [selectedBrands, selectedCategories, onFilter]);

  const apiRef = useTreeViewApiRef();
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h4">Filters</Typography>
      </Grid>
      {/* <Stack
        height={75}
        direction={
          Object.keys(selectedBrands).length > 0 ? 'column' : 'column-reverse'
        }
      >
        <Typography fontWeight={700} m={1}>
          Brands
        </Typography>
        {Object.keys(selectedBrands).length > 0 ? (
          <Chip
            label={`${
              Object.keys(selectedBrands).length
            } brands selected / Clear All`}
            onClick={() => setSelectedBrands([])}
            sx={{ mx: 1, mb: 1 }}
          />
        ) : null}
      </Stack>
      <FormControl sx={{ px: 2, width: '100%' }}>
        <FormGroup>
          {brands?.pages[brandPageIndex]?.items?.map((brand: any) => (
            <FormControlLabel
              value={brand.id || ''}
              checked={selectedBrands.includes(brand.id)}
              control={
                <Checkbox
                  onChange={() => {
                    setSelectedBrands((prev) => {
                      if (prev[brand.id]) {
                        const { [brand.id]: _, ...current } = prev;
                        return current;
                      }
                      return {
                        ...prev,
                        [brand.id]: true,
                      };
                    });
                  }}
                />
              }
              label={brand.name}
              key={brand.id}
            />
          ))}
        </FormGroup>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mr={2}
        >
          <IconButton
            onClick={() => setBrandPageIndex((prev) => prev - 1)}
            disabled={brandPageIndex <= 0}
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography variant="caption">Page {brandPageIndex + 1}</Typography>
          <IconButton
            onClick={() => {
              if (brandPageIndex + 1 < (brands?.pages.length || 0))
                setBrandPageIndex((prev) => prev + 1);
              else
                fetchBrandsNextPage().then(({ data }) => {
                  if (!data) return;
                  if ((data?.pages.length || 0) > brandPageIndex + 1)
                    setBrandPageIndex((prev) => prev + 1);
                });
            }}
            // disabled={!table.getCanNextPage()}
          >
            {isFetchingBrands ? (
              <CircularProgress size={12} />
            ) : (
              <KeyboardArrowRight />
            )}
          </IconButton>
        </Stack>
      </FormControl> */}
      <Grid item xs={12}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">Category</Typography>
          <Button
            onClick={() => setSelectedCategories([])}
            color="error"
            endIcon={<DeleteOutline />}
          >
            Remove All
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          placeholder="Type to search..."
          renderInput={(params) => (
            <TextField {...params} placeholder="Search for categories" />
          )}
          value={selectedCategories}
          onChange={(_e, value: any) => setSelectedCategories(value)}
          onInputChange={async (_event, searchTerm, reason) => {
            if (reason === 'reset') return;
            if (searchTerm) {
              setIsSearching(true);
              handleSearchCategories(searchTerm).finally(() =>
                setIsSearching(false)
              );
              return;
            }
            setCategorySearchResults([
              { id: -1, label: 'Show Parent Categories' },
            ]);
          }}
          options={categorySearchResults}
          filterOptions={(v) => v}
          getOptionLabel={(option: any) => option?.label}
          renderOption={(props, option: any, state) => {
            if (option.id === -1)
              return (
                <RichTreeViewPro
                  apiRef={apiRef}
                  key={option.id}
                  items={parentCategories}
                  dataSource={{
                    getChildrenCount: (item) => item.childrenCount,
                    getTreeItems: getChildCategories,
                  }}
                  checkboxSelection
                  multiSelect
                  selectedItems={selectedCategories.map((c) => c.id)}
                  onSelectedItemsChange={(_, itemIds) =>
                    setSelectedCategories(
                      itemIds.map((id) => apiRef.current?.getItem(id))
                    )
                  }
                  sx={{
                    '.MuiTreeItem-content': {
                      py: 1,
                    },
                  }}
                />
              );
            const { inputValue } = state;
            const parts: string[] =
              option?.label?.split(new RegExp(`(${inputValue})`, 'gi')) || [];
            return (
              <Stack component="li" {...props}>
                <Typography variant="body1" textAlign="left" width="100%">
                  {parts.map((part, i) => (
                    <Box
                      component="span"
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${part}-${i}`}
                      sx={
                        part.toLowerCase() === inputValue.toLowerCase()
                          ? { fontWeight: 700 }
                          : undefined
                      }
                    >
                      {part}
                    </Box>
                  ))}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  textAlign="left"
                  width="100%"
                >
                  {option.displayText}
                </Typography>
              </Stack>
            );
          }}
          open={popoverOpen}
          onOpen={() => setPopoverOpen(true)}
          onClose={(_, reason) => reason !== 'blur' && setPopoverOpen(false)}
          loading={isSearching}
          loadingText="Searching..."
          noOptionsText="Type to search"
          limitTags={3}
          multiple
          fullWidth
          disableClearable
          disableCloseOnSelect
          slotProps={{
            paper: {
              sx: {
                '.MuiAutocomplete-listbox': { maxHeight: '65vh' },
              },
            },
          }}
        />
      </Grid>
      {/* <Stack
        height={75}
        direction={
          Object.keys(selectedCategories).length > 0
            ? 'column'
            : 'column-reverse'
        }
      >
        <Typography fontWeight={700} m={1}>
          Categories
        </Typography>
        {Object.keys(selectedCategories).length > 0 ? (
          <Chip
            label={`${
              Object.keys(selectedCategories).length
            } brands selected / Clear All`}
            onClick={() => setSelectedCategories({})}
            sx={{ mx: 1, mb: 1 }}
          />
        ) : null}
      </Stack>
      <FormControl sx={{ px: 2, width: '100%' }}>
        <FormGroup>
          {categories?.pages[categoriesPageIndex]?.items?.map(
            (category: any) => (
              <FormControlLabel
                value={category.name}
                checked={selectedCategories[category.id] || false}
                control={
                  <Checkbox
                    onChange={() => {
                      setSelectedCategories((prev) => {
                        if (prev[category.id]) {
                          const { [category.id]: _, ...current } = prev;
                          return current;
                        }
                        return {
                          ...prev,
                          [category.id]: true,
                        };
                      });
                    }}
                  />
                }
                label={category.name}
                key={category.id}
              />
            )
          )}
        </FormGroup>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mr={2}
        >
          <IconButton
            onClick={() => setCategoriesPageIndex((prev) => prev - 1)}
            disabled={categoriesPageIndex <= 0}
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography variant="caption">
            Page {categoriesPageIndex + 1}
          </Typography>
          <IconButton
            onClick={() => {
              if (categoriesPageIndex + 1 < (categories?.pages.length || 0))
                setCategoriesPageIndex((prev) => prev + 1);
              else
                fetchCategoriesNextPage().then(({ data }) => {
                  if (!data) return;
                  if ((data?.pages.length || 0) > categoriesPageIndex + 1)
                    setCategoriesPageIndex((prev) => prev + 1);
                });
            }}
            // disabled={!table.getCanNextPage()}
          >
            {isFetchingCategories ? (
              <CircularProgress size={12} />
            ) : (
              <KeyboardArrowRight />
            )}
          </IconButton>
        </Stack>
      </FormControl> */}
      <Grid item xs={12}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">Brand</Typography>
          <Button
            onClick={() => setSelectedBrands([])}
            color="error"
            endIcon={<DeleteOutline />}
          >
            Remove All
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          placeholder="Type to search..."
          value={selectedBrands}
          onChange={(_e, value: any) => setSelectedBrands(value)}
          noOptionsText="No matches"
          filterOptions={(options) => options}
          renderInput={(params) => (
            <TextField {...params} placeholder="Search for brands" />
          )}
          onInputChange={(_event, searchTerm) => {
            setIsSearching(true);
            handleSearchBrands(searchTerm).finally(() => setIsSearching(false));
          }}
          options={brands || []}
          getOptionLabel={(option: any) => option?.name}
          renderOption={(props, option: any, state) => {
            const { inputValue } = state;
            const parts: string[] =
              option?.name?.split(new RegExp(`(${inputValue})`, 'gi')) || [];
            return (
              <Box component="li" {...props}>
                <Typography variant="body1" textAlign="left" width="100%">
                  {parts.map((part, i) => (
                    <Box
                      component="span"
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${part}-${i}`}
                      sx={
                        part.toLowerCase() === inputValue.toLowerCase()
                          ? { fontWeight: 700 }
                          : undefined
                      }
                    >
                      {part}
                    </Box>
                  ))}
                </Typography>
              </Box>
            );
          }}
          multiple
          fullWidth
          disableClearable
        />
      </Grid>
    </Grid>
  );
};

export default ProductFilters;
